import React, { Component } from 'react';
import PropTypes from 'prop-types'
import {
  lockStyle,
  leftWrap,rightWrap,
  leftPaddingRect,rightPaddingRect,
  leftRect,rightRect
} from './style.css'
import {
  omitIcon,omitStyle,nestOffset,wrongStyle,deleteStyle,addStyle,lineStyle,jsonKeyStyle
} from './viewToOmit.css'
import { Icon } from 'bee'

function parseJsonByStringify(json){
  let temp = JSON.stringify(json,null,'\*')
  let jsonArray = temp.split('\n')
  let showJson = jsonArray.map( (v,k) =>{
    let regFlag = v.match(/^[\*]*/)
    v = v.replace(/^[\*]*/,"")
    let flagNum = regFlag[0]
    let tempLength = flagNum.length
    let valWrap = (
      <div key={k} style={{"marginLeft":`${tempLength*8}px`}}>
        {v}
      </div>
    )
    return valWrap
  })
  return showJson
}

//根据json数据类型来返回对应字符串(非对象)
function parseJson2StringByType(json){
  let parsedResult = ''
  if(typeof(json) === "string" ){
    parsedResult = `\"${json}\"`
  }else if(typeof(json) == 'number'){
    parsedResult = json;
  }else if(typeof(json) == 'boolean'){
    parsedResult = json+'';
  }else if(!json && typeof(json)!=='undefined' && json!==0){
    parsedResult = 'null'
  }else if(typeof(json)=='undefined'){
    parsedResult = "undefined"
  }
  return parsedResult
}
/**
 * topTypeIsArray 第一层是数组还是对象 
 * leftMode || singleMode left左侧 none 右侧 single 单一json
 * originJsonData 左json
 * jsonData 右json
 * nestDegree 嵌套层级 默认0 暂时未开放设置 暂不起作用
 */

class ViewToOmit extends Component{
  constructor(props){
    super(props)
    let { jsonData = {} } = props
    let omit = Object.keys(jsonData).reduce( (prev,v) =>{
      prev[v] = false
      return prev
    },{})
    this.state={
      omit:omit
    }
  }
  componentWillReceiveProps(nextProps){
    let { jsonData = {} } = nextProps
    let omit = Object.keys(jsonData).reduce( (prev,v) =>{
      prev[v] = false
      return prev
    },{})
    this.setState({
      omit:omit
    })
  }
  toggleOmit = (index) =>{
    this.setState(prev =>{
      prev.omit[index] = !prev.omit[index]
      let omit = prev.omit
      return {
        omit
      }
    })
  }
  render(){
    let { omit } = this.state
    let { singleMode,leftMode,jsonData={},originJsonData={},topTypeIsArray,nestDegree=0 } = this.props
    let addOrDeStyle = addStyle
    if(singleMode){
      addOrDeStyle = ''
    }else if(leftMode){
      addOrDeStyle = deleteStyle
    }else{
      addOrDeStyle = addStyle
    }
    let totalNum = Object.keys(jsonData).length;
    let jsonView = Object.keys(jsonData).map((v,k) =>{
      let jsonKey = v,
          jsonValue = jsonData[v];   
      let currentOmit = omit[jsonKey]
      let hasKey_verify = originJsonData && !(Array.prototype.isPrototypeOf(originJsonData) ^ Array.prototype.isPrototypeOf(jsonData)) && originJsonData.hasOwnProperty(v),
          originJsonValue = originJsonData && originJsonData[v],
          hasSameValue_verify = JSON.stringify(jsonValue) === JSON.stringify(originJsonValue);
      const omitSpan = (
        <span className={omitStyle} onClick={this.toggleOmit.bind(null,jsonKey)} >
          <Icon type="uf-arrow-left" />
          <Icon type="uf-3dot-h" />
          <Icon type="uf-arrow-right" />
        </span>
      )
      return (
        <div key={k} className={lineStyle} >
          {
            jsonValue && typeof(jsonValue) == "object"?
            <Icon className={ omitIcon } type={currentOmit?'uf-anglearrowpointingtoright':'uf-treearrow-down'} onClick={this.toggleOmit.bind(null,v)} />:
            null
          }
          {
            !topTypeIsArray?
            <span className={`${!hasKey_verify?addOrDeStyle:''} ${jsonKeyStyle}`}>{jsonKey}<span>&nbsp;:&nbsp;</span></span>:
            null
          }
          {
            jsonValue && typeof(jsonValue) == "object"?
              Array.prototype.isPrototypeOf(jsonValue)?
                (
                  <span className={!hasKey_verify?addOrDeStyle:Array.prototype.isPrototypeOf(originJsonValue)?'':wrongStyle}>
                    <span>[</span>
                    {
                      jsonValue.length>0?
                        currentOmit?
                          omitSpan:
                          <div className={nestOffset}>
                            {
                              jsonValue.some( v => v && typeof(v) == "object" )?
                                <ViewToOmit singleMode={singleMode} leftMode={leftMode} nestDegree={nestDegree+1} topTypeIsArray={true} jsonData={jsonValue} originJsonData={originJsonValue} />:
                                <span className={!hasKey_verify?addOrDeStyle:''}>
                                {
                                  jsonValue.map( (v,k) =>{
                                    let flag = true//add为新增,true/false为是否匹配
                                    if(!hasKey_verify){
                                      flag = true
                                    }else if(!Array.prototype.isPrototypeOf(originJsonValue)){
                                      flag = false
                                    }else{
                                      if(k > originJsonValue.length-1){
                                        flag = 'add'
                                      }else{ 
                                        flag = v == originJsonValue[k]
                                      }
                                    }
                                    if(k<jsonValue.length-1){
                                      return <span key={k} className={flag=='add'?addOrDeStyle:flag?'':wrongStyle} >{parseJson2StringByType(v)},</span>
                                    }
                                    return <span key={k} className={flag=='add'?addOrDeStyle:flag?'':wrongStyle} >{parseJson2StringByType(v)}</span>
                                  })
                                }
                                </span>
                            }
                          </div>:
                        <span>&nbsp;&nbsp;</span>
                    }
                    <span>]</span>
                  </span>
                ):
                ( 
                  <span className={!hasKey_verify?addOrDeStyle:typeof(originJsonValue)=='object'&&!Array.prototype.isPrototypeOf(originJsonValue)?'':wrongStyle}>
                    <span>{'{'}</span>
                    {
                      Object.keys(jsonValue).length>0?
                        currentOmit?omitSpan:
                        <div className={nestOffset}>
                          { <ViewToOmit  singleMode={singleMode} leftMode={leftMode} nestDegree={nestDegree+1} jsonData={jsonValue} originJsonData={originJsonValue} /> }</div>:
                        <span>&nbsp;&nbsp;</span>
                    }
                    <span>{'}'}</span>
                  </span>
                ):
              ( 
                <span className={!hasKey_verify?addOrDeStyle:hasSameValue_verify?"":wrongStyle}>
                { parseJson2StringByType(jsonValue) }
                </span>
              )
          }
          {
            k<totalNum-1?',':''
          }
        </div>
      )
    })
    return (
      <div>
        {
          jsonView
        }
      </div>
    )
  }
}

export default class JsonViewer extends Component {
  constructor(props){
    super(props)
    this.state={
      leftOmit:false,
      rightOmit:false,
      lockState:true,
      lockNum:0,
    }
  }
  componentWillMount(){
    let { jsonDataLeft,jsonDataRight } = this.props;
    this.setState({
      jsonDataOrigin:jsonDataLeft,
      jsonDataNew:jsonDataRight
    })
  }
  componentWillReceiveProps(nextProps){
    let { jsonDataLeft,jsonDataRight } = nextProps;
    this.setState({
      jsonDataOrigin:jsonDataLeft,
      jsonDataNew:jsonDataRight,
      lockState:true,
      lockNum:0,
    })
  }
  toggleLeftOmit = ()=>{this.setState(prev => ({leftOmit:!prev.leftOmit}))}
  toggleRightOmit = ()=>{this.setState(prev => ({rightOmit:!prev.rightOmit}))}
  createLeftJsonView = (originJsonData,jsonData,isArray) => <ViewToOmit topTypeIsArray={isArray} leftMode originJsonData={originJsonData} jsonData={ jsonData } nestDegree={0} />
  createRightJsonView = (originJsonData,jsonData,isArray) => <ViewToOmit topTypeIsArray={isArray} originJsonData={originJsonData} jsonData={ jsonData } nestDegree={0} />

  handleScroll = (state,e) =>{
    if(e.target.classList.contains('rectInner'))return
    let scrollTop = e.target.scrollTop
    if(scrollTop>0){
      this[`${state}FixDom`].classList.add('fixed')
    }else{
      this[`${state}FixDom`].classList.remove('fixed')
    }
    let { lockState, lockNum } = this.state;
    if(!lockState)return 
    if(state == 'left'){
      this.rightRectDom.scrollTop = scrollTop+lockNum
    }else if(state == 'right'){
      this.leftRectDom.scrollTop = scrollTop-lockNum
    }
  }
  toggleLockState = ()=>{
    let lockNum = 0;
    // 未锁 -> 锁上 记录 lockNum
    if(!this.state.lockState){
      lockNum = this.rightRectDom.scrollTop - this.leftRectDom.scrollTop
    }
    this.setState({
      lockState:!this.state.lockState,
      lockNum,
    })
  }
   
  render(){
    let { leftOmit,rightOmit,jsonDataOrigin, jsonDataNew ,lockState } = this.state
    // let showJson = parseJsonByStringify(jsonDataOrigin)
    let isLeftJsonArray = Array.isArray(jsonDataOrigin),
        isRightJsonArray = Array.isArray(jsonDataNew),
        isJsonTypeSame = !(isLeftJsonArray ^ isRightJsonArray);
    let jsonViewLeft =  jsonDataOrigin == null ? null : this.createLeftJsonView(jsonDataNew,jsonDataOrigin,isLeftJsonArray)
    let jsonViewRight =  jsonDataNew == null ? null :this.createRightJsonView(jsonDataOrigin,jsonDataNew,isRightJsonArray)
    const omitSpan = leftOrRight => (
      <span className={omitStyle} onClick={()=>{leftOrRight=='left'?this.toggleLeftOmit():this.toggleRightOmit()}} >
        <Icon type="uf-arrow-left" />
        <Icon type="uf-3dot-h" />
        <Icon type="uf-arrow-right" />
      </span>
    )
    return (
      <div style={{'height':'100%',position:'relative'}}>
        <Icon type='uf-link' className={`${lockStyle} ${lockState?'locked':''}`} onClick={this.toggleLockState} />
        <div className={leftWrap}>
          <div className='leftTitle' ref={node=>this.leftFixDom = node} >
            <div>
            {this.props.leftTitle.time || '' } {/** unkonwn */}
            </div>
            <div style={{lineHeight:'14px'}}>
              {this.props.leftTitle.name || ''} {/** unkonwn */}
            </div>
          </div>
          <div className={leftPaddingRect}>
          <div className={leftRect} ref={node=>this.leftRectDom = node} onScroll={this.handleScroll.bind(null,'left')}>
            <div className="rectInner">
              <Icon className={ omitIcon } type={leftOmit?'uf-anglearrowpointingtoright':'uf-treearrow-down'} onClick={this.toggleLeftOmit} />
              {
                jsonViewLeft == null ? 
                <div className={nestOffset}>
                  { parseJson2StringByType(jsonViewLeft) }
                </div>:
                <span>
                  <span className={isJsonTypeSame?'':wrongStyle}>{!isLeftJsonArray?"{":"["}</span>
                  {
                    leftOmit?
                    omitSpan('left'):
                    <div className={nestOffset}>
                      {jsonViewLeft}
                    </div>
                  }
                  <span className={isJsonTypeSame?"":wrongStyle}>{!isLeftJsonArray?"}":"]"}</span>
                </span>
              }
            </div>
          </div>
          </div>
        </div>
        <div className={rightWrap}>
          <div className='rightTitle' ref={node=>this.rightFixDom = node}>
            <div>
              {this.props.rightTitle.time || ''}{/** unkonwn */}
              </div>
              <div style={{lineHeight:'14px'}}>
                {this.props.rightTitle.name || ''}{/** unkonwn */}
              </div>
          </div>
          <div className={rightPaddingRect}>
          <div className={rightRect} ref={node=>this.rightRectDom = node} onScroll={this.handleScroll.bind(null,'right')}>
            <div className="rectInner">
              <Icon className={ omitIcon } type={rightOmit?'uf-anglearrowpointingtoright':'uf-treearrow-down'} onClick={this.toggleRightOmit} />
              {
                jsonViewRight == null ? 
                <div className={nestOffset}>
                  { parseJson2StringByType(jsonViewRight) }
                </div>:
                <span>
                  <span className={isJsonTypeSame?"":wrongStyle}>{!isRightJsonArray?"{":"["}</span>
                  {
                    rightOmit?
                    omitSpan('right'):
                    <div className={nestOffset}>
                    {jsonViewRight}
                    </div>
                  }
                  <span className={isJsonTypeSame?"":wrongStyle}>{!isRightJsonArray?"}":"]"}</span>
                </span>
              }
            </div>
          </div>
          </div>
        </div>
      </div>
    )   
  }
}


/**
 * title
 * jsonData
 */
export class SingleJsonViewer extends Component {
  constructor(props){
    super(props)
    this.state={
      omit:false,
    }
  }
  componentWillMount(){
    let { jsonData } = this.props;
    this.setState({
      jsonData,
    })
  }
  componentWillReceiveProps(nextProps){
    let { jsonData } = nextProps;
    this.setState({
      jsonData,
    })
  }
  toggleOmit = ()=>{this.setState(prev => ({omit:!prev.omit}))}
  createJsonView = (originJsonData,jsonData,isArray) => <ViewToOmit topTypeIsArray={isArray} singleMode originJsonData={originJsonData} jsonData={ jsonData } nestDegree={0} />
   
  render(){
    let { omit, jsonData } = this.state
    let isJsonArray = Array.isArray(jsonData);
    let jsonView =  jsonData == null ? null : this.createJsonView({},jsonData,isJsonArray)
    const omitSpan = () => (
      <span className={omitStyle} onClick={this.toggleOmit} >
        <Icon type="uf-arrow-left" />
        <Icon type="uf-3dot-h" />
        <Icon type="uf-arrow-right" />
      </span>
    )
    return (
      <div style={{'height':'100%',position:'relative'}}>
        <div className={`${leftWrap} single-style`}>
          <div className='leftTitle' ref={node=>this.leftFixDom = node} >
            <div>
            {this.props.title.time || ''}{/** unkonwn */}
            </div>
            <div style={{lineHeight:'14px'}}>
              {this.props.title.name || ''}{/** unkonwn */}
            </div>
          </div>
          <div className={leftPaddingRect}>
          <div className={leftRect} ref={node=>this.leftRectDom = node}>
            <div className="rectInner">
              <Icon className={ omitIcon } type={omit?'uf-anglearrowpointingtoright':'uf-treearrow-down'} onClick={this.toggleOmit} />
              {
                jsonView == null?
                <div className={nestOffset}>
                  { parseJson2StringByType(jsonView) }
                </div>:
                <span>
                  <span>{!isJsonArray?"{":"["}</span>
                  {
                    omit?
                    omitSpan():
                    <div className={nestOffset}>
                      {jsonView}
                    </div>
                  }
                  <span>{!isJsonArray?"}":"]"}</span>
                </span>
              }
            </div>
          </div>
          </div>
        </div>
      </div>
    )   
  }
}


// WEBPACK FOOTER //
// ./src/components/zTestJson/index.js